"use client";
import React, { useState, useEffect } from "react";
import FullScreenLoader from "@/components/Common/FullScreenLoader";

const PreLoader = () => {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 100);
  }, []);

  return loading && <FullScreenLoader color="blue" size="lg" />;
};

export default PreLoader;
